import script from "./Padrao.vue?vue&type=script&setup=true&lang=ts"
export * from "./Padrao.vue?vue&type=script&setup=true&lang=ts"

import "./Padrao.vue?vue&type=style&index=0&id=363f906f&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363f906f"]])

export default __exports__